export default "__VITE_ASSET__DAPnue_n__"